import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideFunnelSampleContentInitializer } from 'shared/src/services/funnel-sample-content.service';
import { provideStatsigInitializer } from '../../../funnel/src/app/app.config';
import { FunnelFlowService } from '../../../funnel/src/app/services/funnel-flow.service';
import { QuizRouteReuseStrategy } from '../../../funnel/src/app/services/quiz-route-reuse-strategy';
import { PROJECT_NAME, ProjectNames } from '../../../shared/src/tokens';
import { routes } from './app.routes';
import { GoogleFunnelFlowService } from './services/google-funnel-flow.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    {
      provide: PROJECT_NAME,
      useValue: ProjectNames.GOOGLE_FUNNEL,
    },
    {
      provide: RouteReuseStrategy,
      useClass: QuizRouteReuseStrategy,
    },
    provideFunnelSampleContentInitializer(),
    provideStatsigInitializer(),
    {
      // Override the FunnelFlowService with Google variant
      provide: FunnelFlowService,
      useClass: GoogleFunnelFlowService,
    },
  ],
};
